import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import "./Register.css";

const USERS_BASE_URL = import.meta.env.VITE_USERS_BASE_URL;
const SITE_NAME = import.meta.env.VITE_SITE_NAME;

function Register() {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    password_confirm: "",
    country_code: "",
    phone_number: "",
  });
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setError("");
  };

  const handleRegister = async () => {
    try {
      const response = await fetch(`${USERS_BASE_URL}/register/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
        ...formData,
        site_name: SITE_NAME
        })
      });

      const data = await response.json();

      if (data.message === "Registration successful. Please verify your email.") {
        navigate("/verify-otp", {
          state: { email: formData.email }
        });
      } else {
        setError(data.error || "Registration failed");
      }
    } catch (error) {
      setError("Registration failed. Please try again.");
    }
  };

  return (
    <div className="register-container">
      <div className="register-box">
        <img src={logo} alt="App Logo" className="logo" />
        <h2>Register</h2>
        {error && <p className="error-message">{error}</p>}

        <label className="label">First Name</label>
        <input
          className="input"
          type="text"
          name="first_name"
          value={formData.first_name}
          onChange={handleChange}
          placeholder="Enter first name"
          required
        />

        <label className="label">Last Name</label>
        <input
          className="input"
          type="text"
          name="last_name"
          value={formData.last_name}
          onChange={handleChange}
          placeholder="Enter last name"
          required
        />

        <label className="label">Email</label>
        <input
          className="input"
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Enter email"
          required
        />

        <label className="label">Password</label>
        <input
          className="input"
          type="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          placeholder="Enter password"
          required
        />

        <label className="label">Confirm Password</label>
        <input
          className="input"
          type="password"
          name="password_confirm"
          value={formData.password_confirm}
          onChange={handleChange}
          placeholder="Confirm password"
          required
        />

        <div className="phone-input-group">
          <div>
            <label className="label">Country Code</label>
            <input
              className="input"
              type="text"
              name="country_code"
              value={formData.country_code}
              onChange={handleChange}
              placeholder="+1"
            />
          </div>

          <div>
            <label className="label">Phone Number</label>
            <input
              className="input"
              type="text"
              name="phone_number"
              value={formData.phone_number}
              onChange={handleChange}
              placeholder="1234567890"
            />
          </div>
        </div>

        <button className="button" onClick={handleRegister}>
          Register
        </button>

        <div className="links">
          <a href="/login" className="link">
            Already have an account? Login
          </a>
        </div>
      </div>
    </div>
  );
}

export default Register;
